export const boardAnnouncementTemplates = {
  production: '643946fcb827fb03bdb2746c',
  development: '643e72ae7bd72a038d982b0c',
  test: '643e72ae7bd72a038d982b0c',
};

export const boardActTemplates = {
  production: '6465d69904c24a62270abe63',
  development: '646399b4fea19f3ade3ac149',
  test: '646399b4fea19f3ade3ac149',
};

export const boardActCertificateTemplates = {
  production: '6465d6b204c24a62270abe68',
  development: '6463a7906855422ba0f676f1',
  test: '6463a7906855422ba0f676f1',
};

export const boardDelegationTemplates = {
  production: '646362ceae93250e8718de1e',
  development: '64635aab1c3def25e4b41032',
  test: '64635aab1c3def25e4b41032',
};
